"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ThemeProvider = require("../ThemeProvider");
var _LinkBase = _interopRequireDefault(require("./LinkBase"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Link = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    href,
    children,
    accessibilityRole = 'link',
    variant = {},
    tokens,
    dataSet,
    ...linkProps
  } = _ref;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('Link', tokens, variant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinkBase.default, {
    href: href,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    ref: ref,
    dataSet: dataSet,
    ...linkProps,
    children: children
  });
});
Link.displayName = 'Link';
Link.propTypes = {
  ..._LinkBase.default.propTypes,
  /**
   * The dataSet prop allows to pass data-* attributes element to the component.
   */
  dataSet: _propTypes.default.object
};
var _default = exports.default = Link;